<template>
  <div class="p-4 border-2 rounded-lg shadow-md w-full max-w-sm mx-auto ag-overlay-loading-center">
    <p class="text-center">
      {{ params.isLoading ? "Loading..." : "Please select a hospital" }}
    </p>
  </div>
</template>

<script>
export default {
  name: "LoadingOverlay",
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
};
</script>

